// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rUESJ","image":"styles_image__gfgwj","cards":"styles_cards__hShV-","card":"styles_card__8REyP"};